<template>
  <CustomerList role-type="clin-trans" title="Clin-trans" />
</template>

<script>
import CustomerList from "./customer-list";

export default {
  name: "Clin-trans-Customer-List",
  components: {CustomerList}
}
</script>

<style scoped>

</style>